import React, { Component } from 'react'
import { getQuestions } from '../../actions'
import './styles.scss'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import contractIcon from '../../../../_static/images/contract.png'
import { CREATE_DIALOG, showModal } from '../../../../modules/modals'
import { connect } from 'react-redux'

export class DialogsList extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  constructor(props) {
    super(props)
  
    this.state = {
      list: [],
      loaded: false
    }
  }
  
  async componentDidMount(){
    const list = await getQuestions();
    this.setState({list, loaded: true})
  }

  handleCreateDialog = () => {
    let {showModal} = this.props
    showModal({modalType : CREATE_DIALOG, modalProps: {onLoaded: async () => {
      this.setState({ loaded: false})
      const list = await getQuestions();
      this.setState({list, loaded: true})
    }}})
  }

  render() {
    const {formatMessage} = this.context;
    const {setSelectedDialog, selectedDialog} = this.props;
    const { loaded, list } = this.state;
    return (
      <div className='DialogsList'>
        <div className='HeaderDialog'>{formatMessage('myQuestionUser')}</div>
        <div onClick={this.handleCreateDialog} className="row-list__item-title">
            <img
                className="row-list__item-icon row-list__item-icon--indent-right vam"
                src={contractIcon}
                alt=""
            />
            <span className="vam">{formatMessage("Create a request")}</span>
        </div>
        {list.filter(_i => _i.parent_id == 0).map(_i => <div 
          className={classNames('item', {active: selectedDialog == _i.id})} 
          key={'question_' + _i.id} 
          onClick={() => setSelectedDialog(_i.id)}
        >
          <div className='rowList'>
            <div className='name'>{_i.name}</div>
            <div className='date'>{moment(_i.created_at * 1000).format('MM-DD-yyyy')}</div>
          </div>
          <div className='rowList'>
            <div className='message'>{_i.question}</div>
          </div>
        </div>)}
      </div>
    )
  }
}

export default connect(
  state => ({}),
  {showModal}
)(DialogsList)





// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Support/components/DialogsList/DialogsList.js